import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary'
import { QueryProvider } from './providers/QueryProvider'
import { ToastProvider } from './components/Toast'
import { RegistrationFlowProvider } from './contexts/RegistrationFlowContext'
import { ThemeProvider } from './contexts/ThemeContext'

// Initialize theme from localStorage (only in browser)
if (typeof window !== 'undefined') {
  const savedTheme = localStorage.getItem('theme') || 'dark';
  document.documentElement.setAttribute('data-theme', savedTheme);
}

// Global error handler for uncaught errors (only in browser)
if (typeof window !== 'undefined') {
  window.onerror = (
    message: string | Event,
    source?: string,
    lineno?: number,
    colno?: number,
    error?: Error
  ): void => {
    console.error('Global uncaught error:', {
      message,
      source,
      lineno,
      colno,
      error,
      url: window.location.href,
      timestamp: new Date().toISOString(),
    });
  };

  // Global handler for unhandled Promise rejections
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    console.error('Unhandled Promise rejection:', {
      reason: event.reason,
      url: window.location.href,
      timestamp: new Date().toISOString(),
    });
  });
}

// Only render in browser environment
if (typeof window !== 'undefined' && document.getElementById('root')) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <QueryProvider>
            <ThemeProvider>
              <RegistrationFlowProvider>
                <ToastProvider>
                  <App />
                </ToastProvider>
              </RegistrationFlowProvider>
            </ThemeProvider>
          </QueryProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
